import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { BatchAttendanceModifyRequest } from "./BatchAttendanceModifyRequest";
import { BatchAttendanceImportCompareRequest } from "./batch-attendance-import-compare-request";
@Injectable()
export class DataService_batchattendance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	loadSelectionVals(SchoolID, DropList) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/LoadBatchAttendanceValues?SchoolID=" + SchoolID + "&DropList=" + DropList;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadAttendanceExcuses(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/AttendanceExcuseSelectList?SchoolID=" + SchoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceBatchInsert(parms: BatchAttendanceModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/AttendanceBatchInsert?";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceBatchUpdate(parms: BatchAttendanceModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/AttendanceBatchUpdate?";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BatchAttendanceImportCompare(parms: BatchAttendanceImportCompareRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/BatchAttendanceImportCompare";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
